var _path, _polygon, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRollFabricInsert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 436.8 566.9",
    enableBackground: "new 0 0 436.8 566.9",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#000000",
    strokeMiterlimit: 10,
    d: "M37.9,552"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#D2D2D2",
    stroke: "#878787",
    strokeMiterlimit: 10,
    points: "33.6,122.2 393.9,41.7 393.9,389.9 395,459.5 35.7,551.9  "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D2D2",
    stroke: "#878787",
    strokeMiterlimit: 10,
    d: "M59.3,154.7c0,0,330-77.7,339-77.7s22.8-11.9,21.4-35.2 c-1.4-23.3-17.1-24.3-17.1-24.3L60.5,87.5L46.2,88v66.7H59.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#878787",
    strokeMiterlimit: 10,
    d: "M17,154.7h41.7c0,0,9.5-6.1,11.4-28.2C72.6,98.2,60.5,88,60.5,88 H33.6h-7.7H17V154.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#878787",
    strokeMiterlimit: 10,
    d: "M60.5,88H17.7c-0.1,0-0.8-0.3-0.7-0.3L368.5,15l33.2,2.6 c0.1,0,0.1,0.1,0,0.1L60.5,88z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRollFabricInsert);
export default __webpack_public_path__ + "static/media/roll_fabric_insert.580099e91494e539d376ccdd4f5f58a2.svg";
export { ForwardRef as ReactComponent };